export const permissions = {
  // Role = Student
  STUDENT: 'STUDENT',
  STUDENT_IN_ASSOC_HIGH_SCHOOL: 'STUDENT_IN_ASSOC_HIGH_SCHOOL',
  STUDENT_RECEIVES_NOTIFICATIONS: 'STUDENT_RECEIVES_NOTIFICATIONS',
  VIEW_STUDENT_ATTACHMENTS: 'VIEW_STUDENT_ATTACHMENTS',
  CREATE_STUDENT_ATTACHMENTS: 'CREATE_STUDENT_ATTACHMENTS',
  UPDATE_STUDENT_ATTACHMENTS: 'UPDATE_STUDENT_ATTACHMENTS',
  DELETE_STUDENT_ATTACHMENTS: 'DELETE_STUDENT_ATTACHMENTS',

  // Role = CareerExploreStudent
  VIEW_ANY_CAREER: 'VIEW_ANY_CAREER',
  PERFORM_CAREER_SEARCH: 'PERFORM_CAREER_SEARCH',

  // Role = CollegeExploreStudent
  VIEW_ANY_COLLEGE_DETAIL: 'VIEW_ANY_COLLEGE_DETAIL',
  PERFORM_COLLEGE_SEARCH: 'PERFORM_COLLEGE_SEARCH',
  PERFORM_POSTS_SEARCH: 'PERFORM_POSTS_SEARCH',
  PERFORM_PROGRAM_SEARCH: 'PERFORM_PROGRAM_SEARCH',
  VIEW_MS_GRADE_COLLEGE_EVENTS: 'VIEW_MS_GRADE_COLLEGE_EVENTS',

  // Role = MessengerStudent
  SEARCH_FOR_STAFF_IN_ASSOC_HIGH_SCHOOL: 'SEARCH_FOR_STAFF_IN_ASSOC_HIGH_SCHOOL',
  PARTICIPATE_IN_DISCUSSIONS: 'PARTICIPATE_IN_DISCUSSIONS',
  PARTICIPATE_IN_VISIT_DISCUSSIONS: 'PARTICIPATE_IN_VISIT_DISCUSSIONS',

  // Role = CollegeProspectStudent
  CAN_DOWNLOAD_STUDENT_PROFILE: 'CAN_DOWNLOAD_STUDENT_PROFILE',
  CAN_INVITE_PARENTS: 'CAN_INVITE_PARENTS',
  CAN_VIEW_STUDENT_AND_PARENT_SURVEYS: 'CAN_VIEW_STUDENT_AND_PARENT_SURVEYS',
  CREATE_RECOMMENDATION_REQUEST_IN_ASSOC_HIGH_SCHOOL: 'CREATE_RECOMMENDATION_REQUEST_IN_ASSOC_HIGH_SCHOOL',
  DELETE_RECOMMENDATIONS_IN_ASSOC_HIGH_SCHOOL: 'DELETE_RECOMMENDATIONS_IN_ASSOC_HIGH_SCHOOL',
  PERFORM_EVENT_SEARCH: 'PERFORM_EVENT_SEARCH',
  PERFORM_PREFERENCE_SEARCH: 'PERFORM_PREFERENCE_SEARCH',
  STUDENT_RECEIVES_OUTREACH_MESSAGES: 'STUDENT_RECEIVES_OUTREACH_MESSAGES',
  VIEW_COLLEGE_OUTREACH_MESSAGES: 'VIEW_COLLEGE_OUTREACH_MESSAGES',
  VIEW_COLLEGE_PROSPECTS_FOR_SELF: 'VIEW_COLLEGE_PROSPECTS_FOR_SELF',
  VIEW_COLLEGE_PROSPECT_DOCS_FOR_SELF: 'VIEW_COLLEGE_PROSPECT_DOCS_FOR_SELF',
  VIEW_REDACTED_ASSESSMENT_PROSPECTS_FOR_ASSOC_HIGH_SCHOOL: 'VIEW_REDACTED_ASSESSMENT_PROSPECTS_FOR_ASSOC_HIGH_SCHOOL',
  VIEW_VISITS_FOR_ASSOC_HIGH_SCHOOL: 'VIEW_VISITS_FOR_ASSOC_HIGH_SCHOOL',
  VIEW_HS_GRADE_COLLEGE_EVENTS: 'VIEW_HS_GRADE_COLLEGE_EVENTS',

  // Role = CommonAppUser
  CONNECT_COMMON_APP_ACCOUNT: 'CONNECT_COMMON_APP_ACCOUNT',
  DISCONNECT_COMMON_APP_ACCOUNT: 'DISCONNECT_COMMON_APP_ACCOUNT',
}
